import panelAccessTypes from "../../../actionTypes/panelAccessTypes";

const initialState = {
  accesssibleFeatures: new Set(),
  restrictedFeatures: new Set(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case panelAccessTypes.SET_FEATURES: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};
